import { Control, Controller, useWatch } from "react-hook-form";
import { Tool, VariableDefinition } from "../AssistantDetailsContent";
import { FlowsField } from "../FlowsField";
import { NoxusFormEntryConfig } from "@/components/Spotflow/ConfigDrawer/ConfigDrawer";
import { useMemo } from "react";

export const WorkflowsFieldNCL = ({
  name,
  control,
  isDisabled,
  defaultValue,
  itemConfig,
}: {
  name: string;
  control: Control<Record<string, unknown>>;
  isDisabled?: boolean;
  defaultValue?: unknown;
  itemConfig?: Record<string, NoxusFormEntryConfig>;
}) => {
  // Derive the sibling field path from the workflows field path
  // e.g. "definition.workflows" -> "definition.variables"
  const variablesFieldName = name.replace(/\.workflows$/, ".variables");
  const enabledFieldName = name.replace(/\.workflows$/, ".variables_enabled");
  const variables = useWatch({ control, name: variablesFieldName }) as
    | VariableDefinition[]
    | undefined;
  const variablesEnabled = useWatch({ control, name: enabledFieldName }) as
    | boolean
    | undefined;

  // Whatever the agent declares, independent of the enable toggle. Whether the
  // External value mode is offered at all is the picker's call (flag + toggle);
  // this is only the list of names it can bind to, and blanking it would leave
  // an already-bound input with nothing to show.
  const agentVariables = useMemo(
    () => variables?.filter((v) => v.name).map((v) => ({ name: v.name })) || [],
    [variables]
  );

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => {
        const value = field.value as Tool[] | undefined;
        return (
          <FlowsField
            tools={value}
            onToolsChange={field.onChange}
            isDisabled={isDisabled}
            itemConfig={itemConfig}
            agentVariables={agentVariables}
            externalValuesEnabled={!!variablesEnabled}
          />
        );
      }}
    />
  );
};
